import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { BaseApiService } from '../../../core/services/base-api.service';
import { EmailMetrics, EmailEffectivenessMetrics, CampaignFilterOptions, EmailReadershipRate, EmailRejectionRate, CampaignSummary } from '../campaign-analytics.model';
import { AppConfigService } from '../../../core/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignAnalyticsService extends BaseApiService {
  constructor(http: HttpClient, appConfigService: AppConfigService) {
    super(http, appConfigService);
  }

  getEmailMetrics(filters: CampaignFilterOptions): Observable<EmailMetrics[]> {
    // Construct query parameters
    let queryParams = '';
    if (filters) {
      const params = [];
      if (filters.fromDate) params.push(`fromDate=${filters.fromDate}`);
      if (filters.toDate) params.push(`toDate=${filters.toDate}`);
      
      if (params.length > 0) {
        queryParams = `?${params.join('&')}`;
      }
    }
    return this.get<EmailMetrics[]>(`campaigns/email-metrics`, filters);
  }
  
  getEmailEffectivenessMetrics(filters: CampaignFilterOptions): Observable<EmailEffectivenessMetrics[]> {
    return this.get<EmailEffectivenessMetrics[]>(`campaigns/email-effectiveness-metrics`, filters);
  }
  
  getEmailReadershipRate(filters: CampaignFilterOptions): Observable<EmailReadershipRate[]> {
    return this.get<EmailReadershipRate[]>(`campaigns/email-readership-rate`, filters);
  }
  
  getEmailRejectionRate(filters: CampaignFilterOptions): Observable<EmailRejectionRate[]> {
    return this.get<EmailRejectionRate[]>(`campaigns/email-rejection-rate`, filters);
  }
  
  getCampaignSummary(filters: CampaignFilterOptions): Observable<CampaignSummary> {
    // Make the API call
    return this.get<CampaignSummary>(`campaigns/campaigns-summary`, filters);
  }
  
  // Add more methods for other chart data as needed
} 